import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  ApplicationListRequest,
  ApplicationListResponse,
  Application,
  ApplicationCreateRequest,
  ApplicationUpdateRequest,
  ApplicationShortListRequest,
  ApplicationShortListResponse,
} from "./types";

/**
 * List
 */
export const applicationAppsService = (params: ApplicationListRequest) =>
  RestAPIClient.call<ApplicationListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.Apps,
    config: {
      params,
      requireAuthentication: true,
    },
  });

/**
 * List short
 */
export const applicationListShortService = (
  params: ApplicationShortListRequest
) =>
  RestAPIClient.call<ApplicationShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const applicationDetailService = (id: number) =>
  RestAPIClient.call<Application>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const applicationCreateService = (data: ApplicationCreateRequest) =>
  RestAPIClient.call<Application>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const applicationUpdateService = (data: ApplicationUpdateRequest) =>
  RestAPIClient.call<Application>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update status
 */
export const applicationUpdateStatusService = ({
  id,
  isActive,
}: {
  id: number;
  isActive: boolean;
}) =>
  RestAPIClient.call<Application>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
  });
